import { InputUploadToCloudLibrary, OutputUploadToCloudLibrary } from "@/types";
import * as library from "@/lib/library";
import { AbstractJob } from "../job";

export class JobUploadToCloudLibrary extends AbstractJob<
  InputUploadToCloudLibrary,
  OutputUploadToCloudLibrary
> {
  public readonly type = "upload-to-cloud-library";
  public readonly name = "Upload to Cloud Library";

  async run() {
    const output = await library.uploadToCloudLibrary(
      this.input,
      (progress: number) => this.emit("progress", progress),
      this.controller.signal
    );

    return output;
  }
}
